Librarian.Modules.FastLaneTileList = new Class({
    Extends: Librarian.Modules.Module, 
    Binds: ["renderContent", "startLoadingPhase", "endLoadingPhase", "renderBreadcrumb", "onBreadcrumbClicked", "load"], 

    options: {
        classPrefix: "modules-fastlanetilelist-",
        id: "fastLaneTileList"
    },

    breadcrumb: [],
    prevFolderInfo: null,

    /* Module Methods */

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);

        // start loading screen
        // prevent event getting called twice because of tab double-load bug
        Librarian.FastLane.removeEvents("fastlane-start-loading-phase");
        Librarian.FastLane.addEvent("fastlane-start-loading-phase", this.startLoadingPhase);

        // render tile list items
        // prevent event getting called twice because of tab double-load bug
        Librarian.FastLane.removeEvents("fastlane-content-ready-to-render");
        Librarian.FastLane.addEvent("fastlane-content-ready-to-render", this.renderContent);
    },  

    load: function() {
        var self = this,
            folderClicked = false;

        // check module wrapper
        if (!this.wrapperEl) { return; }

        var pureElement = this.wrapperEl.getParent();
        var rowElement = pureElement.getParent();

        this.parent();

        // check module container
        if (!this.containerEl) { return; }
        
        // set styles so module can be height of whole page
        pureElement.setStyle("height", "100%");
        rowElement.setStyle("height", "100%");
        this.wrapperEl.setStyle("height", "100%");
        this.containerEl.setStyle("height", "100%");

         // initialize breadcrumb element
        this.breadcrumbEl = new Element("div", {
            id: "fastLaneTileListBreadcrumb"
        });
        this.breadcrumbEl.inject(this.containerEl);

        // initialize pageheader container
        this.pageheadercontainerEl = new Element("div", {
            id: "fastLaneTileListPageheader"
        });
        this.pageheadercontainerEl.inject(this.containerEl);

        // initialize tile list
        this.tileList = new Librarian.TileList({
            id: "fastlane-tile-list",
            container: this.containerEl,
            itemStyle: "tile-list-item",
            allowDrag: true,
            size: Librarian.fastlane.defaultViewType
        });
        this.tileList.options.targetList = window.tileList;
        Librarian.FastLane.tileList = this.tileList;

        this.tileList.testParam = "this is the real fastlane tileList";

        // set no folder selected background image
        this.containerEl.setStyle("background-image", "url('" + Librarian.path.getLayoutsPath() + "/core/fastlane/img/nofolderselected.png" + "')");

        if(Librarian.fastlane.loadTopFolderAsDefault) {
            // select top folder as default
            var topFolder = $("fastlaneFolderListFoldersContainer");
            if (this.options.selectedFolder){
                topFolder.childNodes.forEach(function(element){
                    if (folderClicked)
                        return;

                    var folderName = element.get("text");
                    if (folderName == self.options.selectedFolder) {
                        element.click();
                        folderClicked = true;
                    }
                });
            }
            if(topFolder && topFolder.childNodes[0] && !folderClicked) {
                topFolder.childNodes[0].click();
            }
        }
        
    }, 

    /* Tile List Methods */

    renderContent: function() {

        // manage breadcrumb
        this.manageBreadcrumb(Librarian.FastLane.LoadedContent.folderInfo);

        // load info in tile list
        this.tileList.loadFromArray(Librarian.FastLane.LoadedContent.items, Librarian.FastLane.LoadedContent.categories, 1);

        // create pageheader
        Librarian.pageHeader = new Librarian.PageHeader({
            id: this.pageheadercontainerEl.get("id"),
            headerType: Librarian.headerTypes.fastlane,
            name: " ",
            useLargePageNumber: true,
            allowCollapse: false,
            getPageHeaderMenuBar: Library.getPageHeaderMenuBar, 
            showHeaderMenu: true
        });

        this.endLoadingPhase();
        Librarian.FastLane.fireEvent("fastlane-content-view-finished-loading");
    },


    /* Breadcrumb Methods */

    manageBreadcrumb: function(folderInfo) {
        if(folderInfo) {
            // prevents duplicate breadcrumb entry
            if(this.prevFolderInfo) {
                if(folderInfo.catid && this.prevFolderInfo.catid) {
                    if(folderInfo.catid === this.prevFolderInfo.catid) { return; }
                } else {
                    if(folderInfo.type === this.prevFolderInfo.type && folderInfo.title === this.prevFolderInfo.title) { return; }
                }
            }

            // add new entry to end of breadcrumb
            this.addToBreadcrumb(folderInfo);
            this.renderBreadcrumb();

            this.prevFolderInfo = folderInfo;
        } 
        else {
            // folder type does not use breadcrumb
            this.clearBreadcrumb();
            this.renderBreadcrumb();
        }
    },

    clearBreadcrumb: function() {
        this.breadcrumb = [];
        this.prevFolderInfo = null;
    }, 

    addToBreadcrumb: function(folderInfo) {
        this.breadcrumb.push(folderInfo);
    },

    renderBreadcrumb: function() {
        var self = this;

        // empty current breadcrumb element
        this.breadcrumbEl.empty();

        // build crumb for each item in breadcrumb
        this.breadcrumb.forEach(function(crumb, index) {
            
            new Element("span", {
                class: "fastLaneTileListCrumb",
                text: crumb.title,
                events: {
                    click: function() { self.onBreadcrumbClicked(crumb); }
                }
            }).inject(self.breadcrumbEl);

            if(index < (self.breadcrumb.length - 1)) {
                new Element("span", {
                    class: "fastLaneTileListCrumbSpacer",
                    text: ">>"
                }).inject(self.breadcrumbEl);
            }

        });
    },

    onBreadcrumbClicked: function(crumb) {
        var self = this;

        if(crumb.type === "globalfavorites") {
            // load clicked crumb
            this.clearBreadcrumb();
            Librarian.FastLane.loadGlobalFavorites();
        }
        else {

            this.breadcrumb.forEach(function(item, index) {
                // find which crumb needs to be loaded
                if(crumb.catid === item.catid && item.catid != null) {
                    // slice breadcrumb, remove all crumbs after clicked crumb
                    self.breadcrumb = self.breadcrumb.slice(0, index);

                    // load clicked crumb
                    Librarian.FastLane.loadFolder(item);
                }
            });

        }
    },
     

    /* Loading Phase Methods */

    startLoadingPhase: function() {
        // clear tile list
        this.tileList.reset();

        this.clearBreadcrumb();

        // show loading icon
        var tileListEl = $("module_fastLaneTileList");
        if(tileListEl) {
            tileListEl.setStyle("background-image", "url(\"" + Librarian.path.getLayoutsPath() + "core/fastlane/img/loading-spinner.gif" + "\")");
        }
        
    }, 

    endLoadingPhase: function() {
        // remove loading icon
        var tileListEl = $("module_fastLaneTileList");
        if(tileListEl) {
            tileListEl.setStyle("background-image", "none");
        }

    }

});